window.$app.perf.setTag('mainLoaded');

// Wait for app setup to finish
await window.$app.appSetup;

window.$app.perf.setTag('mainLoadsAppRoot');

// Import app-root components
await import('./app-root');

window.$app.perf.setTag('appRootLoaded');

// To tell TypeScript this is a module
export {}; // NOSONAR
